import { discover_feed_interest_path, discover_feed_interests_path } from "@routes/routes";
import {
  DiscoverFeedInterestShowResponse,
  DiscoverFeedInterestsIndexResponse,
} from "@tsTypes/discover_feed_interests/index";
import request from "./request";

export const getDiscoverFeedInterests = async (): Promise<DiscoverFeedInterestsIndexResponse> => {
  const response = await request.get(discover_feed_interests_path());
  return response.data;
};

export const createDiscoverFeedInterest = async (
  description: string
): Promise<DiscoverFeedInterestShowResponse> => {
  const response = await request.post(discover_feed_interests_path(), { description });
  return response.data;
};

export const updateDiscoverFeedInterest = async (
  id: number,
  description: string
): Promise<DiscoverFeedInterestShowResponse> => {
  const response = await request.patch(discover_feed_interest_path(id), { description });
  return response.data;
};

export const deleteDiscoverFeedInterest = async (id: number): Promise<{ success: boolean }> => {
  const response = await request.delete(discover_feed_interest_path(id));
  return response.data;
};
